import type { enStokProcurement } from '../en/stok-procurement';

export const idStokProcurement: Record<keyof typeof enStokProcurement, string> = {
  // ---- Status
  'stok.procStatus.po.draft': 'Draf',
  'stok.procStatus.po.pending_approval': 'Menunggu persetujuan',
  'stok.procStatus.po.approved': 'Disetujui',
  'stok.procStatus.po.partially_received': 'Diterima sebagian',
  'stok.procStatus.po.received': 'Diterima',
  'stok.procStatus.po.closed': 'Ditutup',
  'stok.procStatus.po.cancelled': 'Dibatalkan',
  'stok.procStatus.gr.draft': 'Draf',
  'stok.procStatus.gr.posted': 'Diposting',
  'stok.procStatus.gr.cancelled': 'Dibatalkan',

  // ---- Pemasok
  'stok.suppliers.title': 'Pemasok',
  'stok.suppliers.subtitle': 'Dipakai bersama oleh semua cabang usaha.',
  'stok.suppliers.add': 'Tambah pemasok',
  'stok.suppliers.readOnly':
    'Hanya baca — mengubah pemasok butuh izin pembelian untuk seluruh usaha.',
  'stok.suppliers.listTitle': 'Daftar pemasok',
  'stok.suppliers.listDesc': 'Tempat Anda membeli, lengkap dengan kontak dan termin pembayaran.',
  'stok.suppliers.searchPlaceholder': 'Kode, nama, kontak, telepon, atau email',
  'stok.suppliers.empty':
    'Belum ada pemasok — tambahkan satu untuk mulai membuat pesanan pembelian.',
  'stok.suppliers.emptyReadOnly':
    'Belum ada pemasok — muncul setelah bagian pembelian menambahkannya.',
  'stok.suppliers.code': 'Kode',
  'stok.suppliers.codeHint': 'Singkat dan unik, mis. SUP-01. Tidak bisa diubah kemudian.',
  'stok.suppliers.codeLocked': 'Kode tidak bisa diubah.',
  'stok.suppliers.contact': 'Nama kontak',
  'stok.suppliers.phone': 'Telepon',
  'stok.suppliers.email': 'Email',
  'stok.suppliers.taxId': 'NPWP',
  'stok.suppliers.address': 'Alamat',
  'stok.suppliers.terms': 'Termin pembayaran',
  'stok.suppliers.termsLabel': 'Termin pembayaran (hari)',
  'stok.suppliers.termsHint': '0 = tunai saat barang datang; paling lama 365 hari.',
  'stok.suppliers.termsCash': 'Tunai',
  'stok.suppliers.termsDays': '{days} hari',
  'stok.suppliers.activeLabel': 'Aktif',
  'stok.suppliers.activeHint': 'Pemasok nonaktif tidak bisa dipilih untuk pesanan pembelian baru.',
  'stok.suppliers.editNamed': 'Ubah {name}',
  'stok.suppliers.createTitle': 'Pemasok baru',
  'stok.suppliers.editTitle': 'Ubah pemasok',
  'stok.suppliers.formDesc': 'Pemasok dipakai bersama oleh semua cabang.',
  'stok.suppliers.createSubmit': 'Tambah pemasok',
  'stok.suppliers.saved': 'Pemasok {name} disimpan.',
  'stok.suppliers.err.code':
    'Gunakan huruf, angka, titik, tanda hubung, atau garis bawah (maks. 20).',
  'stok.suppliers.err.codeTaken': 'Kode ini sudah dipakai pemasok lain.',
  'stok.suppliers.err.email': 'Masukkan alamat email yang valid.',
  'stok.suppliers.err.terms': 'Masukkan jumlah hari bulat dari 0 sampai 365.',

  // ---- Pesanan pembelian
  'stok.po.title': 'Pesanan pembelian',
  'stok.po.subtitle': 'Pesanan ke pemasok untuk cabang ini, terbaru di atas.',
  'stok.po.create': 'Buat pesanan',
  'stok.po.readOnly': 'Hanya baca — membuat dan mengubah pesanan butuh izin pembelian.',
  'stok.po.noPermission': 'Anda tidak punya akses ke pesanan pembelian di cabang ini.',
  'stok.po.noManage': 'Minta pengguna bagian pembelian membuat pesanan.',
  'stok.po.listTitle': 'Pesanan',
  'stok.po.listDesc': 'Buka pesanan untuk melihat baris, persetujuan, dan progres penerimaan.',
  'stok.po.searchPlaceholder': 'Nomor PO atau pemasok',
  'stok.po.statusFilter': 'Saring menurut status',
  'stok.po.empty': 'Belum ada pesanan pembelian — buat pesanan pertama untuk pemasok.',
  'stok.po.emptyReadOnly':
    'Belum ada pesanan pembelian — muncul setelah bagian pembelian membuatnya.',
  'stok.po.emptyFiltered': 'Tidak ada pesanan dengan status ini.',
  'stok.po.number': 'No. pesanan',
  'stok.po.supplier': 'Pemasok',
  'stok.po.expectedDate': 'Perkiraan kirim',
  'stok.po.lineCount': 'Baris',
  'stok.po.total': 'Total',
  'stok.po.backToList': 'Semua pesanan pembelian',
  'stok.po.newTitle': 'Pesanan pembelian baru',
  'stok.po.newSubtitle': 'Disimpan sebagai draf; ajukan persetujuan sebelum barang bisa diterima.',
  'stok.po.detailTitle': 'Pesanan pembelian',
  'stok.po.editTitle': 'Ubah draf {number}',
  'stok.po.editSubtitle': 'Menyimpan akan mengganti semua baris draf.',
  'stok.po.headTitle': 'Rincian pesanan',
  'stok.po.headDesc': 'Pemasok, perkiraan tanggal kirim, dan catatan untuk pemasok.',
  'stok.po.pickSupplier': 'Pilih pemasok',
  'stok.po.notes': 'Catatan',
  'stok.po.linesTitle': 'Baris',
  'stok.po.linesFormDesc':
    'Jumlah dalam satuan yang dipilih, harga per satu satuan sebelum pajak. Maksimal {max} baris.',
  'stok.po.linesDesc': 'Jumlah dipesan dan diterima dalam satuan tiap baris.',
  'stok.po.lineLabel': 'Baris {n}',
  'stok.po.removeLine': 'Hapus baris {n}',
  'stok.po.addLine': 'Tambah baris',
  'stok.po.pickItem': 'Pilih barang',
  'stok.po.qty': 'Jumlah',
  'stok.po.unit': 'Satuan',
  'stok.po.priceLabel': 'Harga per {unit} ({currency})',
  'stok.po.priceHint': 'Angka bulat, tanpa pemisah ribuan.',
  'stok.po.lineTotal': 'Total baris',
  'stok.po.totalLines': 'Total ({count} baris)',
  'stok.po.draftNote': 'Draf masih bisa diubah sampai diajukan untuk persetujuan.',
  'stok.po.saveDraft': 'Simpan draf',
  'stok.po.created': 'Pesanan pembelian {number} disimpan sebagai draf.',
  'stok.po.saved': 'Pesanan pembelian {number} disimpan.',
  'stok.po.noSuppliers': 'Belum ada pemasok aktif — tambahkan dulu:',
  'stok.po.noItems': 'Belum ada barang aktif — tambahkan dulu:',
  'stok.po.err.supplier': 'Pilih pemasok.',
  'stok.po.err.date': 'Masukkan tanggal lengkap.',
  'stok.po.err.notes': 'Gunakan paling banyak 500 karakter.',
  'stok.po.err.noLines': 'Tambahkan minimal satu baris.',
  'stok.po.err.tooManyLines': 'Satu pesanan paling banyak 100 baris.',
  'stok.po.err.item': 'Pilih barang.',
  'stok.po.err.qty': 'Masukkan jumlah lebih dari 0 (maks. 3 desimal).',
  'stok.po.err.unit': 'Pilih satuan.',
  'stok.po.err.precision': 'Jumlah ini tidak bisa dikonversi dengan tepat — gunakan satuan lain.',
  'stok.po.err.price': 'Masukkan harga sebagai angka bulat (0 atau lebih).',
  'stok.po.err.tooLarge': 'Nilainya terlalu besar.',
  'stok.po.err.duplicate': 'Barang dan satuan ini sudah ada di baris lain.',
  'stok.po.factsTitle': 'Pesanan',
  'stok.po.factsDesc': 'Siapa yang membuat dan menyetujui, dan kapan barang diperkirakan datang.',
  'stok.po.createdBy': 'Dibuat oleh',
  'stok.po.approvedBy': 'Disetujui oleh',
  'stok.po.cancelReason': 'Alasan pembatalan',
  'stok.po.closeReason': 'Alasan penutupan',
  'stok.po.ordered': 'Dipesan',
  'stok.po.received': 'Diterima',
  'stok.po.remaining': 'Sisa',
  'stok.po.unitPrice': 'Harga satuan',
  'stok.po.progress': '{received} / {ordered} {unit}',
  'stok.po.editDraft': 'Ubah draf',
  'stok.po.approved': 'Pesanan pembelian {number} disetujui.',
  'stok.po.submit': 'Ajukan persetujuan',
  'stok.po.submitting': 'Mengajukan…',
  'stok.po.submitTitle': 'Ajukan persetujuan pesanan {number}?',
  'stok.po.submitBody': 'Pesanan ke {supplier} tidak bisa diubah selama menunggu persetujuan.',
  'stok.po.submitWarning':
    'Periksa jumlah, harga, dan pos anggaran; langkah persetujuan mengikuti kebijakan untuk jumlah ini.',
  'stok.po.submitted': 'Pesanan pembelian {number} diajukan untuk persetujuan.',
  'stok.po.draftSubmitNote':
    'Draf — ajukan persetujuan setelah lengkap; barang bisa diterima setelah disetujui.',
  'stok.po.awaitingSubmit': 'Draf — bagian pembelian yang mengajukan persetujuan.',
  'stok.po.pendingNote': 'Menunggu persetujuan — lihat langkah persetujuan di bawah.',
  'stok.po.rejectedTitle': 'Persetujuan terakhir ditolak.',
  'stok.po.rejectedBy': 'Ditolak oleh {name} · {time}',
  'stok.po.rejectedHelp': 'Pesanan kembali menjadi draf — perbaiki lalu ajukan lagi.',
  'stok.po.sourceRequest': 'Dari permintaan pembelian',
  'stok.po.openRequest': 'Buka permintaan pembelian',
  'stok.po.cancel': 'Batalkan pesanan',
  'stok.po.cancelling': 'Membatalkan…',
  'stok.po.cancelTitle': 'Batalkan pesanan {number}?',
  'stok.po.cancelBody': 'Pesanan tidak bisa diterima lagi. Stok tidak berubah.',
  'stok.po.cancelBodyCommitted':
    'Pesanan tidak bisa diterima lagi dan persetujuan atau cadangan anggarannya dilepas. Stok tidak berubah.',
  'stok.po.cancelled': 'Pesanan pembelian {number} dibatalkan.',
  'stok.po.close': 'Tutup pesanan',
  'stok.po.closing': 'Menutup…',
  'stok.po.closeTitle': 'Tutup pesanan {number}?',
  'stok.po.closeBody': 'Sisa pesanan tidak akan dikirim. Barang yang sudah diterima tetap di stok.',
  'stok.po.closed': 'Pesanan pembelian {number} ditutup.',
  'stok.po.reason': 'Alasan',
  'stok.po.receive': 'Terima barang',

  // ---- Penerimaan barang
  'stok.gr.title': 'Penerimaan barang',
  'stok.gr.subtitle': 'Barang yang datang untuk pesanan pembelian yang disetujui.',
  'stok.gr.receiveGoods': 'Terima barang',
  'stok.gr.readOnly': 'Hanya baca — mencatat kedatangan barang butuh izin penerimaan.',
  'stok.gr.noPermission': 'Minta pengguna dengan izin penerimaan mencatat kedatangan barang.',
  'stok.gr.readyTitle': 'Siap diterima',
  'stok.gr.readyDesc': 'Pesanan disetujui yang barangnya masih ditunggu.',
  'stok.gr.readyEmpty': 'Tidak ada pesanan yang menunggu — pesanan yang disetujui muncul di sini.',
  'stok.gr.readyNoPermission': 'Anda tidak punya akses ke pesanan pembelian di cabang ini.',
  'stok.gr.readyMeta': '{count} baris · perkiraan {date}',
  'stok.gr.receiveShort': 'Terima',
  'stok.gr.receiveNamed': 'Terima pesanan {number}',
  'stok.gr.listTitle': 'Penerimaan',
  'stok.gr.listDesc': 'Draf masih bisa diubah; penerimaan yang diposting sudah masuk stok.',
  'stok.gr.searchPlaceholder': 'Nomor penerimaan, PO atau pemasok',
  'stok.gr.statusFilter': 'Saring menurut status',
  'stok.gr.empty':
    'Belum ada penerimaan — terima pesanan yang disetujui untuk mencatat kedatangan.',
  'stok.gr.emptyFiltered': 'Tidak ada penerimaan dengan status ini.',
  'stok.gr.number': 'No. penerimaan',
  'stok.gr.po': 'Pesanan pembelian',
  'stok.gr.receivedAt': 'Waktu terima',
  'stok.gr.backToList': 'Semua penerimaan',
  'stok.gr.newTitle': 'Terima barang',
  'stok.gr.newSubtitle': 'Catat yang datang; stok baru berubah saat penerimaan diposting.',
  'stok.gr.pickTitle': 'Pesanan mana yang datang?',
  'stok.gr.pickDesc': 'Pilih pesanan pembelian untuk kiriman ini.',
  'stok.gr.pickPo': 'Pilih pesanan',
  'stok.gr.pickContinue': 'Lanjut',
  'stok.gr.notReceivable':
    'Pesanan {number} tidak bisa diterima (belum disetujui atau sudah selesai).',
  'stok.gr.openPo': 'Buka pesanan',
  'stok.gr.noLocations': 'Cabang ini belum punya lokasi stok aktif — tambahkan dulu:',
  'stok.gr.detailTitle': 'Penerimaan barang',
  'stok.gr.detailSubtitle': '{supplier} · pesanan {po}',
  'stok.gr.headTitle': 'Kiriman untuk pesanan {number}',
  'stok.gr.headDesc': 'Dari {supplier}. Pilih tempat barang disimpan.',
  'stok.gr.deliveryRef': 'No. surat jalan',
  'stok.gr.deliveryRefHint': 'Nomor pada surat jalan dari pemasok.',
  'stok.gr.notes': 'Catatan',
  'stok.gr.linesTitle': 'Baris',
  'stok.gr.linesDesc': 'Kosongkan baris yang barangnya tidak datang. Jumlah dalam satuan pesanan.',
  'stok.gr.viewLinesDesc': 'Dikirim termasuk yang ditolak; hanya barang yang diterima masuk stok.',
  'stok.gr.fillAll': 'Terima semua sisa',
  'stok.gr.fillRemaining': 'Isi sisa',
  'stok.gr.fillRemainingNamed': 'Isi sisa {item}',
  'stok.gr.lineLabel': 'Baris {n}: {item}',
  'stok.gr.lineFacts': 'Dipesan {ordered} · sudah diterima {received} · sisa {remaining}',
  'stok.gr.lineDone': 'Sudah diterima penuh',
  'stok.gr.delivered': 'Dikirim ({unit})',
  'stok.gr.deliveredHint': 'Semua yang datang, termasuk yang ditolak.',
  'stok.gr.rejected': 'Ditolak ({unit})',
  'stok.gr.rejectReason': 'Alasan ditolak',
  'stok.gr.rejectReasonHint': 'Mis. rusak, barang salah, mutu kurang.',
  'stok.gr.lotCode': 'Kode lot',
  'stok.gr.lotHint': 'Kosongkan, sistem membuatnya dari nomor penerimaan.',
  'stok.gr.expiry': 'Kedaluwarsa',
  'stok.gr.expiryHint': 'Sesuai label kemasan. Wajib sebelum posting.',
  'stok.gr.expirySuggested': 'Saran: hari ini + umur simpan {days} hari — periksa label.',
  'stok.gr.manufactured': 'Tanggal produksi',
  'stok.gr.manufacturedOn': 'diproduksi {date}',
  'stok.gr.hold': 'Tahan mutu',
  'stok.gr.holdHint': 'Lot tidak dipakai sampai dilepas.',
  'stok.gr.acceptedPreview': 'Diterima: {qty}',
  'stok.gr.value': 'Nilai',
  'stok.gr.acceptedTotal': 'Nilai barang diterima',
  'stok.gr.newNote': 'Disimpan sebagai draf dulu; posting setelah semuanya diperiksa.',
  'stok.gr.draftSavedNote':
    'Posting menambah barang yang diterima ke stok dan tidak bisa dibatalkan.',
  'stok.gr.saveDraft': 'Simpan draf',
  'stok.gr.created': 'Penerimaan {number} disimpan sebagai draf.',
  'stok.gr.saved': 'Penerimaan {number} disimpan.',
  'stok.gr.post': 'Posting',
  'stok.gr.posting': 'Memposting…',
  'stok.gr.postTitle': 'Posting penerimaan {number}?',
  'stok.gr.postBody': '{count} baris akan diposting ke {location}.',
  'stok.gr.postSavesFirst': 'Perubahan Anda disimpan dulu.',
  'stok.gr.postWarning': 'Jumlah dan nilai stok berubah, dan penerimaan tidak bisa diubah lagi.',
  'stok.gr.posted': 'Penerimaan {number} diposting ({count} mutasi).',
  'stok.gr.cancelDraft': 'Batalkan draf',
  'stok.gr.cancelling': 'Membatalkan…',
  'stok.gr.cancelTitle': 'Batalkan draf {number}?',
  'stok.gr.cancelBody': 'Draf disimpan sebagai dibatalkan. Stok tidak berubah.',
  'stok.gr.cancelWarning': 'Penerimaan yang dibatalkan tidak bisa diposting.',
  'stok.gr.cancelled': 'Penerimaan {number} dibatalkan.',
  'stok.gr.factsTitle': 'Penerimaan',
  'stok.gr.factsDesc': 'Ke mana barang disimpan, serta siapa yang mencatat dan memposting.',
  'stok.gr.createdBy': 'Dicatat oleh',
  'stok.gr.postedBy': 'Diposting oleh',
  'stok.gr.businessDate': 'Tanggal usaha',
  'stok.gr.noLines': 'Penerimaan ini tidak punya baris.',
  'stok.gr.colDelivered': 'Dikirim',
  'stok.gr.colRejected': 'Ditolak',
  'stok.gr.colAccepted': 'Diterima',
  'stok.gr.lotAuto': 'otomatis',
  'stok.gr.onHold': 'Ditahan',
  'stok.gr.resultTitle': 'Penerimaan diposting',
  'stok.gr.resultDesc': 'Mutasi stok berikut telah dibuat.',
  'stok.gr.resultEmpty': 'Tidak ada mutasi stok — semua yang dikirim ditolak.',
  'stok.gr.viewLedger': 'Lihat mutasi',
  'stok.gr.err.location': 'Pilih lokasi.',
  'stok.gr.err.tooLong': 'Gunakan paling banyak {max} karakter.',
  'stok.gr.err.qty': 'Masukkan jumlah (maks. 3 desimal).',
  'stok.gr.err.precision': 'Jumlah ini tidak bisa dikonversi dengan tepat ke satuan dasar.',
  'stok.gr.err.rejectedTooMuch': 'Jumlah ditolak tidak boleh lebih dari yang dikirim.',
  'stok.gr.err.reason': 'Isi alasan barang ditolak.',
  'stok.gr.err.overRemaining': 'Jumlah diterima melebihi sisa pesanan.',
  'stok.gr.err.overReceipt':
    'Melebihi pesanan: dipesan {ordered}, sudah diterima {received}, sisa {remaining}.',
  'stok.gr.err.overOrdered': 'Jumlah diterima akan melebihi pesanan ({ordered}).',
  'stok.gr.err.overReceiptAlert':
    'Ada baris yang menerima lebih dari pesanan — periksa baris yang ditandai.',
  'stok.gr.err.tooLarge': 'Nilainya terlalu besar.',
  'stok.gr.err.date': 'Masukkan tanggal lengkap.',
  'stok.gr.err.expiryRequired': 'Isi tanggal kedaluwarsa sebelum posting.',
  'stok.gr.err.lotExpiryConflict': 'Kode lot ini sudah ada dengan tanggal kedaluwarsa lain.',
  'stok.gr.err.noLines': 'Isi jumlah dikirim untuk minimal satu baris.',
};
